import { v2Request } from './client';

/** Build legacy cartData shape for POST /api/cart/suggestions (Object.keys exclusion). */
export function v2CartToLegacyCartData(cart) {
  const cartData = {
    totalAmount: Number(cart?.totalAmount) || 0,
    totalCount: Number(cart?.totalCount) || 0,
  };
  for (const line of cart?.products ?? []) {
    if (line?.productId) {
      cartData[line.productId] = { id: line.productId };
    }
  }
  return cartData;
}

export async function getCartSuggestions(cart, { includeInCart = true } = {}) {
  const cartData = includeInCart
    ? {
        totalAmount: Number(cart?.totalAmount) || 0,
        totalCount: Number(cart?.totalCount) || 0,
      }
    : v2CartToLegacyCartData(cart);

  const res = await v2Request('/api/cart/suggestions', {
    method: 'POST',
    body: { cartData, includeInCart },
  });
  return Array.isArray(res?.data) ? res.data : [];
}
